module.exports = __webpack_public_path__ + "img/cart.132266cc.svg";